/**
 * Recorrencia do plano (`Plan.interval`), usada para rotular preco e cobranca.
 *
 * A tela de assinatura mostrava o preco sempre com "/mes", entao um plano anual
 * de R$ 358,80 aparecia como se fosse mensal ao lado do encerramento do ciclo.
 * Na duvida vale mensal, que e o padrao do cadastro de planos.
 */
export function ehPlanoAnual(interval: string | null | undefined): boolean {
    return interval === 'yearly';
}
